import { combineReducers } from 'redux';
import authenticationReducer from './Authentication/reducer';
import snackbarReducer from './Snackbar/reducer';
import deleteSearchNotificationReducer from './DeleteSearchNotification/reducer';
import searchNotificationsReducer from './SearchNotifications/reducer';
import loaderNotificationsReducer from './LoaderNotifications/reducer';

export default combineReducers({
  subscriptionId: authenticationReducer,
  searchNotifications: searchNotificationsReducer,
  requestedDeleteSearchNotification: deleteSearchNotificationReducer,
  snackbar: snackbarReducer,
  loader: loaderNotificationsReducer,
});



// WEBPACK FOOTER //
// ./app/NotificationsManager/webPush/reducer.js